module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp-6f433e0f8ca66239baaead7c1fc3203f.png";